import React, { HtmlHTMLAttributes, useEffect, useState } from 'react';

import { colors, typography } from '../../styles/tokens';

import {
  Container,
  Content,
  LogoContainer,
  LogoImage,
  LogoText,
  Nav,
} from './styles';

import logoImg from '../../assets/logo.svg';

interface NavItem {
  label: string;
  href: string;
}

type componentProps = HtmlHTMLAttributes<HTMLDivElement> & {
  nav?: NavItem[];
  ctaLabel?: string;
  ctaHref?: string;
};

const Header: React.FC<componentProps> = ({
  nav = [],
  ctaLabel,
  ctaHref,
  ...rest
}) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    handleScroll();

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Container scrolled={scrolled} {...rest}>
      <Content>
        <LogoContainer to="/">
          <LogoImage src={logoImg} alt="logo" />
          <LogoText>TrenzoX</LogoText>
        </LogoContainer>

        <Nav>
          {nav.map(item => (
            <a key={item.href} href={item.href}>
              {item.label}
            </a>
          ))}
          {ctaHref && ctaLabel && (
            <a
              href={ctaHref}
              style={{
                padding: '11px 20px',
                borderRadius: 999,
                background: colors.primary,
                color: colors.onPrimary,
                fontFamily: typography.displayFontFamily,
                fontWeight: 700,
                fontSize: 14,
              }}
            >
              {ctaLabel}
            </a>
          )}
        </Nav>
      </Content>
    </Container>
  );
};

export { Header };
